import * as React from "react";
import "./Style.css";
import Filtericon from "../../../Assets/Filtericon.svg";
import Filter from "../../../Assets/FilterOval.svg";
import ReplayIcon from "@mui/icons-material/Replay";
import FormControlSelect from "../../FormControl/Index";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import axios from "axios";
import Loader from "../../Loader/Loader";
import { APISalesforceUrl, APIDataUrl, APITokenUrl } from "../../../Utils/Utils";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CloseOutlined } from "@mui/icons-material";
import TuneIcon from "@mui/icons-material/Tune";
import SortIcon from "@mui/icons-material/Sort";
import filtericonmobile from "../../../Assets/filtericonmobile.svg";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function LeadsFilter({
  setTableCommingData,
  setIstableDataFilter,
  setSelectedData,
  selectedData,
  setShowData,
  showData,
  setlastdata,
  lastdata,
  setStatsCountDecisionMaker,
  duplicateHandlePass,
  AiProspectData,
  selectedSeniorityData,
  setSkip,
  
  
  setSelectedSeniorityData,
  selectedCountries,
  setSelectedCountries,
  handleApplyProfile,
  setProfileRecords,
  setSelectedProfile,
  sortOrder,
  setSortOrder,
  resetSortData,
  handleSort,
}) {
  const [selectedIndustry, setSelectedIndustry] = React.useState("");
  const [selectedSeniority, setSelectedSeniority] = React.useState("");
  const [selectedCompany, setSelectedCompany] = React.useState("");
  const [aiDecisionMaker, setAiDecisionMaker] = React.useState({
    region: "",
  });
  const [aidecisiondata, setaidecisiondata] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [AiProfileData, setAiProfileData] = React.useState();
  const [AiProfileCheck, SetAiProfileCheck] = React.useState("");
  const [selectedRegion, setSelectedRegion] = React.useState("");
  const [openLocation, setOpenLocation] = React.useState(false);
  const [selectedRegions, setSelectedRegions] = React.useState([]);
  const [filterRegion, setFilterRegion] = React.useState("");
  const [expandedRegions, setExpandedRegions] = React.useState([]);
  const handleCheckboxChange = (event, item) => {
    if (event.target.checked) {
      setShowData([item]);
    } else {
      setShowData([]);
    }
  };
  const [loading, setLoading] = React.useState(false);
  const [strength, setStrength] = React.useState([]);
  const [isLoadMakerFilters, setIsLoadMakerFilters] = React.useState(false);
  const [FilterLeadData, setFilterLeadData] = React.useState([]);
  const navigate = useNavigate();
  const handleSeniorityChange = (event) => {
    const value = event.target.value;
    setSelectedSeniority(value);
  };
  const handelSenioritydata = (event, item) => {
    if (event.target.checked) {
      setSelectedSeniorityData([...selectedSeniorityData, item]);
    } else {
      setSelectedSeniorityData(
        selectedSeniorityData?.filter((uncheck) => uncheck !== item),
      );
    }
  };
  const handleIndustryChange = (event) => {
    const value = event.target.value;
    setSelectedIndustry(value);
  };

  const handeldata = (event, item) => {
    if (event.target.checked) {
      setSelectedData([...selectedData, item]);
    } else {
      setSelectedData(selectedData?.filter((uncheck) => uncheck !== item));
    }
  };
  const handeldatalast = (event, item) => {
    if (event.target.checked) {
      setlastdata([...lastdata, item]);
    } else {
      setlastdata(lastdata.filter((uncheck) => uncheck !== item));
    }
  };
  const handeldatashow = (event, item) => {
    if (event.target.checked) {
      setShowData([item]);
    } else {
      setShowData(showData.filter((selectedItem) => selectedItem !== item));
    }
  };
  const ResetFilterData = () => {
    setSelectedData([]);
    setShowData([]);
    setStrength([]);
    setSelectedIndustry([]);
    setlastdata([]);
    setSelectedCountries([]);
    setSelectedSeniorityData([]);
    setTableCommingData([]);
    setIstableDataFilter(true);
    setStatsCountDecisionMaker("");
    setSkip(0);
    setProfileRecords(false);
    setSelectedProfile([]);
  };
  const aiDecisionMakerFilters = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/org_filters`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.request?.response);
        setAiDecisionMaker(data);
        const location = data;
        setFilterRegion(location?.data?.region);
        setExpandedRegions(
          Object.keys(location?.data?.region).map((region) => region),
        );
      })
      .catch(() => {});
  };
  React.useEffect(() => {
    if (isLoadMakerFilters) {
      aiDecisionMakerFilters();
      aiDecisionMakerdropdown();
    } else setIsLoadMakerFilters(true);
  }, [isLoadMakerFilters]);

  const aiDecisionMakerdropdown = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APITokenUrl(),
      },
      url: `${APIDataUrl()}/v1/people_filters`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.request?.response);

        setaidecisiondata(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    aiDecisionMakerFilters();
    aiDecisionMakerdropdown();
  }, []);
  const handleAiProFIleChange = (event) => {
    const value = event.target.value;
    setAiProfileData(value);
  };
  const handelAiProfileData = (event, name) => {
    let updatedChecked = [...AiProfileCheck];
    if (event.target.checked) {
      updatedChecked = [name];
    } else {
      updatedChecked = updatedChecked.filter((item) => item !== name);
    }
    SetAiProfileCheck(updatedChecked);
  };
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const isDisabled = (name) =>
    AiProfileCheck?.length > 0 && !AiProfileCheck?.includes(name);
  React.useEffect(() => {
    if (AiProspectData) {
      const dataFilter = AiProspectData?.filter(
        (item) => item?.default === true,
      );
      setFilterLeadData(dataFilter);
    }
  }, [AiProspectData]);
  const combinedData = [
    ...FilterLeadData,
    ...AiProspectData?.filter((item) => !FilterLeadData.includes(item)),
  ];
  const handleRegionChange = (region) => {
    if (selectedRegions.includes(region)) {
      // Deselect region and all its countries
      setSelectedRegions(selectedRegions.filter((r) => r !== region));
      setSelectedCountries(
        selectedCountries.filter(
          (country) => !filterRegion[region].includes(country),
        ),
      );
    } else {
      // Select region and all its countries, ensuring no duplicates
      setSelectedRegions([...selectedRegions, region]);
      setSelectedCountries((prevCountries) => [
        ...new Set([...prevCountries, ...filterRegion[region]]),
      ]);
    }
  };
  const isRegionSelected = (region) => selectedRegions.includes(region);
  const isCountrySelected = (country) => selectedCountries.includes(country);
  const handleAccordionToggle = (region) => {
    if (expandedRegions.includes(region)) {
      setExpandedRegions(expandedRegions.filter((r) => r !== region));
    } else {
      setExpandedRegions([...expandedRegions, region]);
    }
  };
  const handleCountryChange = (country) => {
    if (selectedCountries.includes(country)) {
      // Deselect country
      setSelectedCountries(selectedCountries.filter((c) => c !== country));
    } else {
      // Select country
      setSelectedCountries([...selectedCountries, country]);
    }
  };

  // Mobile View filters
  const [openFilterDrawer, setOpenFilterDrawer] = React.useState(false);
  const [openFilterDetail, setOpenFilterDetail] = React.useState("");
  const handleOpenFilterDrawer = () => setOpenFilterDrawer(true);
  const containerFilterRef = React.useRef(null);
  const handleToggleIndustry = (value) => {
    const currentIndex = selectedData.indexOf(value);
    const newSelected = [...selectedData];
    if (currentIndex === -1) {
      newSelected.push(value);
    } else {
      newSelected.splice(currentIndex, 1);
    }
    setSelectedData(newSelected);
  };
  // const handleToggleDecisionMaker = (value) => {
  //   const currentIndex = showData.indexOf(value);
  //   const newSelected = [...showData];
  //   if (currentIndex === -1) {
  //     newSelected.push(value);
  //   } else {
  //     newSelected.splice(currentIndex, 1);
  //   }
  //   setShowData(newSelected);
  // };
  const handleToggleDecisionMaker = (value) => {
    let newSelected = [];
    if (showData[0] === value) {
      newSelected = [];
    } else {
      newSelected = [value];
    }
    setShowData(newSelected);
  };

  const handleToggleSeniority = (value) => {
    const currentIndex = selectedSeniorityData.indexOf(value);
    const newSelected = [...selectedSeniorityData];
    if (currentIndex === -1) {
      newSelected.push(value);
    } else {
      newSelected.splice(currentIndex, 1);
    }
    setSelectedSeniorityData(newSelected);
  };
  const handleToggleStatus = (value) => {
    const currentIndex = lastdata.indexOf(value);
    const newSelected = [...lastdata];
    if (currentIndex === -1) {
      newSelected.push(value);
    } else {
      newSelected.splice(currentIndex, 1);
    }
    setlastdata(newSelected);
  };

  // Mobile View filters
  const [openSortDrawer, setOpenSortDrawer] = React.useState(false);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="DecisionMaker-filter-main-container">
        <div className="outer-main-prospect-filtersand-buttons">
          <section className="prospect-Filter-main-container">
            <div className="AILeads-Filter1st">
              <div>
                <div className="AiLeads-filter-icons">
                  <img src={Filter} alt="" />
                </div>
                <div>
                  <img src={Filtericon} alt="" />
                </div>
              </div>
            </div>
            <div
              className={
                selectedCountries?.length
                  ? "AILeads-Location-down-red"
                  : "AILeads-Location-down"
              }
            >
              <FormControl
                // onMouseLeave={() => setOpenLocation(false)}
                sx={{ m: 1, minWidth: 120 }}
              >
                <Select
                  open={openLocation}
                  onClose={() => setOpenLocation(false)}
                  onOpen={() => setOpenLocation(true)}
                  value={selectedRegion}
                  onChange={handleRegionChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={KeyboardArrowDownIcon}
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                  }}
                >
                  <MenuItem className="hidedata" value="">
                    <em>Location</em>
                    {selectedCountries?.length === 0 ? (
                      <p>Select</p>
                    ) : (
                      <p>{selectedCountries?.length} Selected</p>
                    )}
                  </MenuItem>
                  <div className="AI-leader-checkbox-and-data-list-outter">
                    {Object.keys(filterRegion).map((region) => (
                      <div key={region} className="leads_loc_filter_inner">
                        <div
                          className={
                            isRegionSelected(region)
                              ? "AI-leader-checkbox-and-data-list location_filter_leads_cont_2"
                              : "AI-leader-checkbox-and-data-list location_filter_leads_cont"
                          }
                        >
                          <div className="checkbox-select-data">
                            {/* <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRegionSelected(region)}
                              onChange={() => handleRegionChange(region)}
                              className={isRegionSelected(region) ? "checkbox-green location_filter_checkbox_2" : "checkbox-green location_filter_checkbox"}
                              color="success"

                            />
                          }
                          label={<MenuItem className="menuitems">{region}</MenuItem>}

                        /> */}
                            <MenuItem className="menuitems">
                              {region}
                            </MenuItem>
                            <span
                              onClick={() => handleAccordionToggle(region)}
                            >
                              <KeyboardArrowDownIcon />
                            </span>
                          </div>
                        </div>
                        {expandedRegions.includes(region) && (
                          <div className="location_filter_leads">
                            {filterRegion[region].map((country) => (
                              <div
                                className="AI-leader-checkbox-and-data-list"
                                key={country}
                              >
                                <div className="checkbox-select-data">
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={isCountrySelected(country)}
                                        onChange={() =>
                                          handleCountryChange(country)
                                        }
                                        className={
                                          isCountrySelected(country)
                                            ? "checkbox-green location_filter_checkbox_2"
                                            : "checkbox-green location_filter_checkbox"
                                        }
                                        color="success"
                                      />
                                    }
                                    label={
                                      <MenuItem className="menuitems">
                                        {country}
                                      </MenuItem>
                                    }
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </Select>
              </FormControl>
            </div>
            <div
              className={
                selectedData?.length
                  ? "AILeads-Filter2nddrop-down-red"
                  : "AILeads-Filter2nddrop-down"
              }
            >
              <FormControlSelect
                formControlData={{
                  value: selectedIndustry,
                  handleChange: handleIndustryChange,
                  selectedData: selectedData,
                  handleCheckboxChange: handeldata,
                  dataList: aidecisiondata?.data?.categories,
                  checked: selectedData,
                }}
                placeholder="Industry"
              />
            </div>
            <div
              className={
                showData?.length
                  ? "AILeads-Filter2nddrop-down-red"
                  : "AILeads-Filter2nddrop-down"
              }
            >
              <FormControlSelect
                formControlData={{
                  value: selectedCompany,
                  handleChange: handleIndustryChange,
                  selectedData: showData,
                  handleCheckboxChange: handeldatashow,
                  dataList: aidecisiondata?.data?.decision_maker,
                  selectedData: showData,
                  checked: showData,
                  type: "radio",
                  dataListType: "decision_maker",
                }}
                placeholder="Decision-maker"
              />
            </div>

            <div
              className={
                selectedSeniorityData?.length
                  ? "AILeads-sinority-down-red"
                  : "AILeads-sinority-down"
              }
            >
              <FormControlSelect
                formControlData={{
                  value: selectedSeniority,
                  handleChange: handleSeniorityChange,
                  selectedData: selectedSeniorityData,
                  handleCheckboxChange: handelSenioritydata,
                  dataList: aiDecisionMaker?.data?.seniority,
                  checked: selectedSeniorityData,
                  type: "radio",
                  dataListType: "Seniority",
                }}
                placeholder="Seniority"
              />
            </div>

            <div
              className={
                lastdata?.length
                  ? "AILeads-sinority-down-red"
                  : "AILeads-sinority-down"
              }
            >
              <FormControlSelect
                formControlData={{
                  value: selectedIndustry,
                  handleChange: handleIndustryChange,
                  selectedData: lastdata,
                  handleCheckboxChange: handeldatalast,
                  dataList: aidecisiondata?.data?.josf_status,
                  checked: lastdata,
                  dataListType: "josf_status",
                  type: "radio",
                }}
                placeholder="Orbit Status"
              />
            </div>
          </section>
          <div className="apply-hit-button">
            <div
              className="inner-apply-button-container"
              onClick={duplicateHandlePass}
            >
              <DoneIcon className="apply-tick-icon" />
              <button
                className="AileadsFilter-Apply-button"
                variant="contained"
              >
                Apply
              </button>
            </div>
          </div>
          <div className="reset-hit-button" onClick={ResetFilterData}>
            <div className="inner-rest-button-container">
              <ReplayIcon className="reset-tick-icon" />
              <button
                className="AileadsFilter-reset-button"
                variant="contained"
              >
                Reset
              </button>
            </div>
          </div>
        </div>
        <div className="MyAiProfile-data-list-container">
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <Select
              value={AiProfileData}
              onChange={handleAiProFIleChange}
              displayEmpty
              IconComponent={KeyboardArrowDownIcon}
              inputProps={{ "aria-label": "Without label" }}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <div>
                      <em className="setSelectProfile-ui">AI Profile</em>
                      <p className="SelectedValue"></p>{" "}
                    </div>
                  );
                }
                return selected;
              }}
              onOpen={handleMenuOpen}
              onClose={handleMenuClose}
            >
              <div className="AI-leade-checkbox-and-data-list-last-filter">
                <div className="checkbox-select-data">
                  {combinedData?.length ? (
                    <>
                      {combinedData.map((item) => (
                        <MenuItem
                          className={`menuitems-last-filter ${
                            isDisabled(item.name) ? "disabled-menuitem" : ""
                          }`}
                          key={item.id}
                          value={item.name}
                          onClick={() => {
                            handleMenuClose();
                            handleApplyProfile(item);
                          }}
                          sx={{
                            color: isDisabled(item.name)
                              ? "lightgray"
                              : "black",
                          }}
                        >
                          <ListItemText primary={item.name} />
                        </MenuItem>
                      ))}
                    </>
                  ) : (
                    <MenuItem
                      className={"menuitems-last-filter"}
                      sx={{
                        color: "black",
                      }}
                    >
                      <ListItemText primary={"Not available"} />
                    </MenuItem>
                  )}
                </div>
              </div>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="prospect-filter-display">
        <div className="w-10-lf"></div>
        <div className="crie-inner-drop-boxes-2pros">
          {selectedCountries?.length ? (
            <>
              {selectedCountries?.map((item) => (
                <div className="crie_selected_names">
                  {item}{" "}
                  <CloseOutlined
                    onClick={() =>
                      setSelectedCountries(
                        selectedCountries?.filter(
                          (uncheck) => uncheck !== item,
                        ),
                      )
                    }
                  />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2pros2">
          {selectedData?.length ? (
            <>
              {selectedData?.map((item) => (
                <div className="crie_selected_names">
                  {item}{" "}
                  <CloseOutlined
                    onClick={() =>
                      setSelectedData(
                        selectedData?.filter((uncheck) => uncheck !== item),
                      )
                    }
                  />
                </div>
              ))}
            </>
          ) : null}
        </div>

        <div className="crie-inner-drop-boxes-2pros2">
          {showData?.length ? (
            <>
              {showData?.map((item) => (
                <div className="crie_selected_names">
                  {item === "Yes" ? "Decision Maker" : "Non-Decision Maker"}
                  <CloseOutlined
                    onClick={() =>
                      setShowData(
                        showData?.filter((uncheck) => uncheck !== item),
                      )
                    }
                  />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2pros">
          {selectedSeniorityData?.length ? (
            <>
              {selectedSeniorityData?.map((item) => (
                <div className="crie_selected_names">
                  {item}{" "}
                  <CloseOutlined
                    onClick={() =>
                      setSelectedSeniorityData(
                        selectedSeniorityData?.filter(
                          (uncheck) => uncheck !== item,
                        ),
                      )
                    }
                  />
                </div>
              ))}
            </>
          ) : null}
        </div>
        <div className="crie-inner-drop-boxes-2pros">
          {lastdata?.length ? (
            <>
              {lastdata?.map((item) => (
                <div className="crie_selected_names">
                  {item === "Available"
                    ? "In SalesForce"
                    : "Not In SalesForce"}{" "}
                  <CloseOutlined
                    onClick={() =>
                      setlastdata(
                        lastdata?.filter((uncheck) => uncheck !== item),
                      )
                    }
                  />
                </div>
              ))}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}
